import type { Cache } from 'swr/_internal';
import useSWRImmutable from 'swr/immutable';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getTableConstraintsFromAPI = async ({ product, crop }, cache) => {
    if (!product) return [];
    try {
        const apiUrl = new URL(
            `${settings.urls.apiDomain}/core/v1/product-datasheets/table-constraints/${product}/?crop=${crop}`,
            window.location.origin
        );
        const cacheKey = `useTableConstraintsForProducts-${product}-${crop}`;
        if (cache) {
            const cachedRes = cache.get(cacheKey);
            if (cachedRes) return cachedRes;
        }
        const res = await axFetch.get(apiUrl.toString());
        if (cache && res.status == 200) {
            cache.set(cacheKey, res.data);
        }

        return res.data;
    } catch (error) {
        return [];
    }
};

export const getEnvironmentRangeFromApi = async ({ id, crop }, cache) => {
    try {
        const apiUrl = new URL(
            `${settings.urls.apiDomain}/core/v1/product-datasheets/environment-ranges/${id}/?crop=${crop}`,
            window.location.origin
        );
        const cacheKey = `useEnvinmentRangesForProducts-${id}-${crop}`;
        if (cache) {
            const cachedRes = cache.get(cacheKey);
            if (cachedRes) return cachedRes;
        }
        const res = await axFetch.get(apiUrl.toString());
        if (cache && res.status == 200) {
            cache.set(cacheKey, res.data);
        }

        return res.data;
    } catch (error) {
        return [];
    }
};

export const getDensitiesFromAPI = async ({ id, crop }, cache?: Cache<any>) => {
    try {
        const apiUrl = new URL(
            `${settings.urls.apiDomain}/core/v1/product-datasheets/densities/${id}/?crop=${crop}`,
            window.location.origin
        );

        const cacheKey = `useDensitiesForProducts-${id}-${crop}`;
        if (cache) {
            const cachedRes = cache.get(cacheKey);
            if (cachedRes) return cachedRes;
        }
        const res = await axFetch.get(apiUrl.toString());
        if (cache && res.status == 200) {
            cache.set(cacheKey, res.data);
        }

        return res.data;
    } catch (error) {
        return [];
    }
};

export const getProductDatasheetConfigFromApi = async ({
    page,
    pageSize = 10,
}: {
    page: number;
    pageSize?: number;
}) => {
    const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/product-datasheets/configs/`, window.location.origin);

    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('page_size', String(pageSize));
    apiUrl.search = params.toString();

    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};

export const useProductDatasheetConfig = ({ page, pageSize = 10 }: { page: number; pageSize?: number }) => {
    const key = { key: 'useProductDatasheetConfig', page, pageSize };
    return useSWRImmutable(key, getProductDatasheetConfigFromApi);
};
